module.exports = __webpack_public_path__ + "static/media/icon-error-404.ea7c5aba.svg";